import { AxiosInstance } from 'axios';

import { cancellable } from '../../cancellable';
import { IUser } from 'src/views/Admin/Users/types';
import { insertId } from '../../insertId';
import * as mapUser from './utils/mapUser';

const toResponse = (response: any): IUser[] => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }

  return Array.isArray(response.result)
    ? response.result.map(mapUser.fromServer)
    : mapUser.fromServer(response.result);
};

export default (api: AxiosInstance, url: string) => (id?: number) => {
  const urlWithId = id ? insertId(url, id) : url;
  return cancellable<IUser[]>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/admin/users/get.ts